@if (show && form) {
  <div [formGroup]="form" [attr.data-qa]="question.key + '_aiValidationUpload'">
    @if (question.label) {
      <label class="form-label" [attr.data-qa]="question.key">
        <question-label-content [question]="question" [isInvalid]="isInvalid" [i18ns]="i18ns"></question-label-content>
      </label>
    }
    <!-- QUESTION INPUT -->
    <div class="btn-wrapper">
      <crds-question-multi-image-ai-validation-upload-input
        (imageUploaded)="onImageUploaded($event)"
        [hasUploadedImages]="hasUploadedImages"
        [form]="form"
        [i18ns]="i18ns"
        [question]="question"
        class="test"
        [attr.data-qa]="'multiImageUploadInput'"
        [clearInput]="clearInputValue"
      ></crds-question-multi-image-ai-validation-upload-input>
    </div>
    <!-- QUESTION EXAMPLE IMAGE OR USER UPLOADED -->
    <div class="image-wrapper" [attr.data-qa]="question.key + '_imageWrapper'">
      @if (!hasUploadedImages) {
        <question-hint [question]="question"></question-hint>
      }
      @if (!hasUploadedImages && images && images.length) {
        <div>
          <crds-image-asset [images]="images" [key]="question.key"></crds-image-asset>
        </div>
      }
      @if (hasUploadedImages) {
        <div [attr.data-qa]="question.key + '_uploadedImages'">
          @for (uploadedImage of value; track uploadedImage; let i = $index) {
            <div class="uploaded-image" [attr.data-qa]="question.key + '_uploadedImage_' + i">
              <validation-results
                [results]="getClassificationResult(i)"
                [type]="question.imageClassification"
                [inProgress]="isValidationInProgress(i)"
                [i18ns]="i18ns"
              ></validation-results>
              <div class="uploaded-image__container">
                <div class="uploaded-image__actions">
                  <div
                    class="uploaded-image__actions-inner"
              [class.uploaded-image__actions-inner--has-detected]="
              getClassificationResult(i)?.boundingBoxes && getClassificationResult(i)?.boundingBoxes?.length > 0
            "
                    >
                    @if (getClassificationResult(i)?.boundingBoxes && getClassificationResult(i)?.boundingBoxes?.length > 0) {
                      <div
                        class="uploaded-image__action"
                        >
                        <jui-button size="sm" (click)="toggleBoundingBox(i)" color="low" [attr.data-qa]="question.key + '_toggleBbox_' + i">
                          {{ getEquipmentTypeLabel() }}
                        </jui-button>
                      </div>
                    }
                    <div class="uploaded-image__action">
                      <jui-button size="sm" (click)="clearImage(i)" title="Remove image" color="low" [attr.data-qa]="question.key + '_removeImage_' + i">{{ getRemoveLabel() }}</jui-button>
                    </div>
                  </div>
                </div>
                <div class="uploaded-image__img uploaded-image--ai-image" (click)="toggleBoundingBox(i)" [attr.data-qa]="question.key + '_imageContainer_' + i">
                  <crds-http-image
                    [id]="question.key + '_' + i + '_temp'"
                    [src]="getImageSource(i)"
                    [fetchMetadata]="true"
                    [skeletonLoaderHeight]="imageSkeletonHeight"
                    (metadataLoaded)="handleMetadataLoaded($event, i)"
                  ></crds-http-image>
                  <bounding-box-overlay
                    [imageIndex]="i"
                    [questionKey]="question.key"
                    [classificationResult]="getClassificationResult(i)"
                    [showOverlay]="isBoundingBoxVisible(i)"
                    >
                  </bounding-box-overlay>
                </div>
              </div>
            </div>
          }
        </div>
      }
    </div>
    <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="large" type="line-scale"></ngx-spinner>
  </div>
}
